export default ({target}) => target.offsetWidth < target.scrollWidth;